import {
  IStockItemProvisioningType,
  ProvisioningType,
} from '@kinet-open-network/shared/data-access/model';

export class StockItemProvisioningType implements IStockItemProvisioningType {
  stockItemId!: string;
  provisioningType!: ProvisioningType;
  provisioningValue!: string | number;
}
